import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";

export class ClientTypeDto extends BaseEntityDto {
  name: string;
  isInternal: boolean;

  toString() {
    return this.name;
  }
}
